module.exports = __webpack_public_path__ + "img/20191021163519709.5f001351.jpg";